import { render } from "./NotificationWidget.vue?vue&type=template&id=0b0122d6&scoped=true"
import script from "./NotificationWidget.vue?vue&type=script&lang=js"
export * from "./NotificationWidget.vue?vue&type=script&lang=js"

import "./NotificationWidget.vue?vue&type=style&index=0&id=0b0122d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0122d6"]])

export default __exports__